import { SET_PROJECTS } from "../../../constants";

export const setProjects = (projects: any = []) => ({
  type: SET_PROJECTS,
  payload: projects,
});
